export async function parseMakeupApiResponse(response) {
  const contentType = response.headers.get('content-type') || '';

  if (!response.ok) {
    throw new Error(await readErrorMessage(response, contentType));
  }

  if (contentType.startsWith('image/')) {
    const blob = await response.blob();
    return {
      type: 'image',
      url: URL.createObjectURL(blob),
    };
  }

  const data = await response.json();

  if (data && data.url) {
    return {
      type: 'status',
      url: data.url,
    };
  }

  if (data && data.imageUrl) {
    return {
      type: 'image-url',
      url: data.imageUrl,
    };
  }

  throw new Error(data?.error || 'Unerwartete Antwort vom Server.');
}

async function readErrorMessage(response, contentType) {
  if (contentType.includes('application/json')) {
    const data = await response.json();
    return data?.error || `HTTP error! status: ${response.status}`;
  }

  const text = await response.text();
  return text || `HTTP error! status: ${response.status}`;
}
